import React from "react";
import {Get, GetFile, Post} from "../../components/request";
import screens from "../../screens";
import {withRouter} from 'react-router-dom';
import {Button, Form} from "react-bootstrap";
import ScreenComponent from "../../components/screenComponent";
import FormGroup from "../../components/formGroup";
import MyCard from "../../components/myCard";
import MyFile from "../../components/myFile";
import MySelect from "../../components/form/mySelect";
import loadParameters from "../../components/loadParameters";
import Moment from "moment";
import LabelToggle from "../../components/labelToggle";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBadgeCheck, faDownload} from "@fortawesome/pro-solid-svg-icons";

class Absence extends ScreenComponent {

    constructor(props) {
        super(props);
        this.inscriptionRef = React.createRef();
        this.state = {
            stillSubmit: false,
            inscriptions: [],
            absence: {},
            isExam: false,
            examens: [],
        };
        this.state.parameters = [];
    }

    async componentDidMount() {
        super.componentDidMount();

        await loadParameters(this, "ExamenID");

        const inscriptions = await this.prepareInscriptions();
        let inscription = inscriptions[0];

        const id = this.props.match.params.id;

        let absence = {
            ...this.state.absence,
            AbsenceEtudiantID: parseInt(id),
            InscriptionID: inscriptions[0].value,
        };

        if (id !== "-1") {
            const {body} = await Get(`/v1/extranet/student/${screens.Absences}/${id}`);
            body.AbsenceEtudiantDateDebut = body.AbsenceEtudiantDateDebut.slice(0, 10);
            body.AbsenceEtudiantDateFin = body.AbsenceEtudiantDateFin.slice(0, 10);
            absence = {...absence, ...body};
            inscription = inscriptions.find(f => f.value === body.InscriptionID);
        } else {
            absence = {
                ...absence,
                SuiviAbsenceValeur: null,
                AbsenceEtudiantDateDebut: Moment(new Date()).format("YYYY-MM-DD"),
                AbsenceEtudiantDateFin: Moment(new Date()).format("YYYY-MM-DD"),
            };
        }

        this.updateState({
            absence: absence,
            inscriptions: inscriptions,
        });

        this.inscriptionRef.current.select.setValue(inscription);

        if (id !== "-1") {
            this.state.examens.forEach(e => {
                e.checked = this.state.absence.AbsenceEtudiantExamenID.includes(e.value);
                e.ref.setState({
                    checked: this.state.absence.AbsenceEtudiantExamenID.includes(e.value)
                });
            })
        }
    }

    updateState(s) {
        this.setState(p => ({
            ...p,
            ...s,
        }));
    }

    async prepareInscriptions() {
        let inscriptions = [];
        let {body} = await Get(`/v1/extranet/student/${screens.Inscriptions}`);

        body.filter(m => m.AnneeAcademiqueValeur.endsWith(new Date().getFullYear() + (Moment(new Date()).isBetween(Moment("1509", "DDMM"), Moment("3112", "DDMM"), 'days', '[]') ? 1 : 0))).map((v) => inscriptions.push({
            value: Number(v.InscriptionID),
            label: `${v.AnneeAcademiqueValeur} / ${v.NiveauCoursLibelle}`
        }));

        for (const item of inscriptions) {
            const {body} = await Get(`/v1/extranet/student/${screens.Inscription}01/${item.value}`);
            item.PAE = body.filter(f => f.ActiviteApprentissageCode !== null).reduce((acc, cur) => {
                acc.push(cur.ActiviteApprentissageCode);
                return acc;
            }, []);
        }

        return inscriptions;
    }

    limitExamens(i) {
        const dateDebut = Moment(this.state.absence.AbsenceEtudiantDateDebut, 'YYYY-MM-DD');
        const dateFin = Moment(this.state.absence.AbsenceEtudiantDateFin, 'YYYY-MM-DD');

        return [...this.state.parameters["ExamenID"]].filter(f => {
            const d = Moment(f.label.slice(1, 11), "DD/MM/YYYY");
            return i.PAE.some(s => f.label.includes(s)) && d.isSameOrAfter(dateDebut) && d.isSameOrBefore(dateFin);
        });
    }

    updateExamens(d, isStartDate) {
        let date = Moment(d, "YYYY-MM-DD");
        const dateDebut = Moment(this.state.absence.AbsenceEtudiantDateDebut, 'YYYY-MM-DD');
        const dateFin = Moment(this.state.absence.AbsenceEtudiantDateFin, 'YYYY-MM-DD');

        let newExamens = [];

        [...this.state.parameters["ExamenID"]].forEach(e => {
            let d = Moment(e.label.slice(1, 11), "DD/MM/YYYY");
            if (isStartDate && d.isSameOrAfter(date) && d.isSameOrBefore(dateFin) && this.state.inscriptions.find(f => f.value === this.state.absence.InscriptionID).PAE.some(s => e.label.includes(s))) {
                newExamens.push(e);
            } else if (!isStartDate && d.isSameOrBefore(date) && d.isSameOrAfter(dateDebut) && this.state.inscriptions.find(f => f.value === this.state.absence.InscriptionID).PAE.some(s => e.label.includes(s))) {
                newExamens.push(e);
            }
        });

        return newExamens;
    }

    renderDocument() {
        return (
            <MyCard header={"Justificatif d'absence"}
                    body={
                        <>
                            {
                                this.state.absence.AbsenceEtudiantFichierJustificatifID != null
                                    ? <><FontAwesomeIcon icon={faBadgeCheck} className={"text-success mr-2"}/> <a
                                        onClick={async (e) => {
                                            await GetFile(`/v1/files/${this.state.absence.AbsenceEtudiantFichierJustificatifID}`, {}, "Téléchargement en cours...", {
                                                render: (
                                                    <>
                                                        <FontAwesomeIcon className="mr-2" icon={faDownload}/>
                                                        Document téléchargé !
                                                    </>
                                                )
                                            }, {
                                                render: (
                                                    <>
                                                        <FontAwesomeIcon className="mr-2" icon={faDownload}/>
                                                        Erreur lors du téléchargement...
                                                    </>
                                                )
                                            }, false);
                                            e.preventDefault();
                                        }}>Fichier
                                        correctement annexé au dossier</a></>
                                    : <>
                                        <p>
                                            <b>Seul le format PDF est accepté et une taille maximum de 8Mo.</b><br/>
                                            <b>Un seul document</b> est attendu pour justifier votre absence.
                                            Dans le cas où vous auriez plusieurs fichiers, merci de créer un PDF regroupant
                                            toutes
                                            les pièces justificatives en un seul document.
                                        </p>
                                        <MyFile label={"Annexer un fichier PDF"}
                                                name={"AbsenceEtudiantFichierJustificatifID"}
                                                accept={"application/pdf"}
                                                maxSizeMB={8}
                                                required={true}
                                                onChange={(id) => this.updateState({
                                                    absence: {
                                                        ...this.state.absence,
                                                        AbsenceEtudiantFichierJustificatifID: id
                                                    }
                                                })}
                                        />
                                    </>
                            }
                        </>
                    }
            />
        );
    }

    renderExamens() {
        const CSS = `
.toggle:last-child { margin-bottom: 0; }
`;

        console.log(this.state.examens);

        return (
            <>
                <style>{CSS}</style>
                <div style={{marginTop: "1rem"}}></div>
                <MyCard header={"Session d'examen"}
                        body={
                            <>
                                <p>Pour quel(s) examen(s) souhaitez-vous faire valoir cette absence?</p>
                                {this.state.examens.map((m) => {
                                    return <LabelToggle key={m.value}
                                                        ref={r => m.ref = r}
                                                        label={m.label}
                                                        onChange={d => m.checked = d.state.checked}
                                                        disabled={this.state.absence.SuiviAbsenceValeur !== null}
                                    />
                                })}
                            </>
                        }
                />
            </>
        );
    }

    renderForm() {
        return (
            <Form onSubmit={this.save.bind(this)}>
                <FormGroup ref={this.inscriptionRef}
                           label={"Inscription liée à l'absence"}
                           name={"InscriptionID"}
                           type={MySelect}
                           isDisabled={this.state.absence.AbsenceEtudiantID !== -1 || this.state.inscriptions.length <= 1}
                           options={this.state.inscriptions}
                           onChange={v => {
                               const examens = this.limitExamens(v);
                               this.updateState({
                                   isExam: examens.length > 0,
                                   examens: examens,
                                   absence: {
                                       ...this.state.absence,
                                       InscriptionID: parseInt(v.value),
                                   }
                               })
                           }}
                           required={true}/>

                <FormGroup type={"date"}
                           defaultValue={this.state.absence.AbsenceEtudiantDateDebut}
                           disabled={this.state.absence.SuiviAbsenceValeur !== null}
                           max={this.state.absence.AbsenceEtudiantDateFin}
                           label={"Date de début de l'absence reprise sur le justificatif"}
                           onChange={d => {
                               const examens = this.updateExamens(d.target.value, true);
                               this.updateState({
                                   isExam: examens.length > 0,
                                   examens: examens,
                                   absence: {
                                       ...this.state.absence,
                                       AbsenceEtudiantDateDebut: d.target.value
                                   }
                               });
                           }}
                           name={"AbsenceEtudiantDateDebut"}
                           required={true}/>

                <FormGroup type={"date"}
                           defaultValue={this.state.absence.AbsenceEtudiantDateFin}
                           disabled={this.state.absence.SuiviAbsenceValeur !== null}
                           min={this.state.absence.AbsenceEtudiantDateDebut}
                           label={"Date de fin de l'absence"}
                           onChange={d => {
                               const examens = this.updateExamens(d.target.value, false);
                               this.updateState({
                                   isExam: examens.length > 0,
                                   examens: examens,
                                   absence: {
                                       ...this.state.absence,
                                       AbsenceEtudiantDateFin: d.target.value
                                   }
                               });
                           }}
                           name={"AbsenceEtudiantDateFin"}
                           required={true}/>

                {this.renderDocument()}
                {this.state.isExam && this.renderExamens()}
                {this.state.absence.SuiviAbsenceValeur === null && <div className={"mt-4"}>
                    <Button type="submit" variant="success" size={"lg"} block disabled={this.state.stillSubmit}>
                        Soumettre
                    </Button>
                </div>}
            </Form>
        )
    }

    save(event = false) {
        event.preventDefault();
        event.stopPropagation();

        if (this.state.stillSubmit === true || !this.state.absence.AbsenceEtudiantFichierJustificatifID) return;

        const data = {
            ...this.state.absence,
            AbsenceEtudiantExamenID: this.state.examens.filter(i => i.ref.state.checked).reduce((acc, cur) => {
                acc.push(cur.value);
                return acc;
            }, [])
        }

        if (!event.currentTarget.checkValidity()) return;

        this.setState({
            stillSubmit: true,
        }, async () => {
            await Post(`/v1/extranet/student/${screens.Absences}`, data, "Sauvegarde en cours..", {render: "Sauvegarde réussie !"}, {render: "Erreur lors de la sauvegarde"});

            this.setState({
                stillSubmit: false,
            }, () => {
                this.props.history.push(process.env.APP_ROOT + 'absences');
            });
        })


    }

    render() {
        return (
            <>
                <section>
                    {this.renderForm()}
                </section>
            </>
        );
    }
}

export default withRouter(Absence);